<template>
    <div class="floating-menu-container left-menu" id="left-menu-container" v-show="!isPreviewMode">
        <a-collapse v-model:activeKey="leftMenuActive" :expand-icon="({ isActive }) => h(ToolFilled, { rotate: isActive ? 90 : 0 })">
            <a-collapse-panel key="1" header="">

                <div class="grid-2">
                    <a-button @click="$emit('action', 'undoClick')" class="btn-secondary" type="primary" title="Desfazer" :icon="h(UndoOutlined)"/>
                    <a-button @click="$emit('action', 'redoClick')" class="btn-secondary" type="primary" title="Refazer" :icon="h(RedoOutlined)"/>
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('action', 'svClick')" :class="activeTool === 'streetview' ? 'btn-active' : 'btn-info'" type="primary" title="Street View (Clique no mapa)" :icon="h('i', { class: 'fa fa-street-view' })"/>
                    <a-input :value="colorSelected" @input="colorInput" type="color" title="Mudar Cor da Seleção" />
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('set-tool', 'translate')" :class="activeTool === 'translate' ? 'btn-active' : 'btn-warning'" type="primary" title="Mover Geometria (Arraste)" :icon="h('i', { class: 'fa fa-arrows' })"/>
                    <a-button @click="$emit('set-tool', 'modify')" :class="activeTool === 'modify' ? 'btn-active' : 'btn-secondary'" type="primary" title="Editar Vértices" :icon="h(EditOutlined)"/>
                    <a-button @click="$emit('set-tool', 'scissors')" :class="activeTool === 'scissors' ? 'btn-active' : 'btn-danger'" type="primary" title="Tesoura (Cortar Geometria Livre)" :icon="h('i', { class: 'fa fa-cut' })"/>

                    <a-button @click="$emit('action', 'snapClick')" :class="isSnapActive ? 'btn-active' : 'btn-secondary'" type="primary" title="Aderência (Snap)" :icon="h('i', { class: 'fa fa-magnet' })"/>
                    <a-button @click="$emit('action', 'verticesClick')" :class="showVertices ? 'btn-active' : 'btn-secondary'" type="primary" title="Mostrar Vértices" :icon="h(AimOutlined)"/>
                    <a-button @click="$emit('set-tool', 'offset')" :class="activeTool === 'offset' ? 'btn-active' : 'btn-warning'" type="primary" title="Offset (Paralela)" :icon="h(ExpandOutlined)"/>
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('set-tool', 'polygon')" :class="activeTool === 'polygon' ? 'btn-active' : 'btn-secondary'" type="primary" title="Desenhar Polígono" :icon="h('i', { class: 'fa-regular fa-square' })"/>
                    <a-button @click="$emit('set-tool', 'linestring')" :class="activeTool === 'linestring' ? 'btn-active' : 'btn-secondary'" type="primary" title="Desenhar Linha" :icon="h(MinusOutlined)"/>
                    <a-button @click="$emit('set-tool', 'point')" :class="activeTool === 'point' ? 'btn-active' : 'btn-secondary'" type="primary" title="Inserir Ponto" :icon="h('i', { class: 'fa fa-location-dot' })"/>
                    <a-button @click="$emit('set-tool', 'text')" :class="activeTool === 'text' ? 'btn-active' : 'btn-secondary'" type="primary" title="Inserir Texto Livre" :icon="h(FontColorsOutlined)"/>
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('action', 'copyClick')" class="btn-secondary" type="primary" title="Copiar" :icon="h(CopyOutlined)"/>
                    <a-button @click="$emit('action', 'pasteClick')" class="btn-secondary" type="primary" title="Colar" :icon="h(SnippetsOutlined)"/>
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('action', 'editDataClick')" type="primary" class="btn-info" title="Editar Atributos" :icon="h('i', { class: 'fa fa-list-alt' })"/>
                    <a-button @click="$emit('action', 'deleteClick')" id="btn-delete" title="Apagar Selecionado" :icon="h(DeleteOutlined)" danger type="primary"/>
                </div>
                <a-divider style="background-color:#ddd; height:2px; margin:10px 0" />

                <div class="grid-2">
                    <a-button @click="$emit('action', 'showDocumentsClick')" class="btn-dark" :class="{ 'btn-active': isDocVisible }" title="Visualizar documentos e imagens" type="primary" :icon="h(FileOutlined)" />
                    <a-button @click="$emit('action', 'gridClick')" class="btn-dark" :class="{ 'btn-active': isGridVisible }" title="Mostrar Grades" type="primary" :icon="h(TableOutlined)" />
                    <a-button @click="$emit('action', 'openPrintModal')" class="btn-dark" type="primary" title="Exportar Mapa (Prévia, PDF, Imagem)" :icon="h(PrinterOutlined)"/>
                    <a-button @click="$emit('action', 'openSaveMenu')" class="btn-success" title="Gravar Alterações" :icon="h(SaveOutlined)"/>
                </div>

            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script setup>
import { ref, h } from "vue";
import { 
    ToolFilled, UndoOutlined, RedoOutlined, DragOutlined, EditOutlined, 
    AimOutlined, ExpandOutlined, MinusOutlined, FontColorsOutlined, 
    CopyOutlined, SnippetsOutlined, DeleteOutlined, FileOutlined, 
    TableOutlined, PrinterOutlined, SaveOutlined 
} from "@ant-design/icons-vue";

const props = defineProps({
    activeTool: String,
    isPreviewMode: Boolean,
    isSnapActive: Boolean,
    showVertices: Boolean,
    isGridVisible: Boolean,
    isDocVisible: Boolean,
    colorSelected: String
});

const emit = defineEmits(['set-tool', 'action', 'update-color']);

const leftMenuActive = ref(['1']);

const colorInput = (e) => {
    emit('update-color', e.target.value);
};
</script>

<style scoped>
:deep(.ant-collapse .ant-collapse-content-box) { 
    padding: 10px 3px !important; 
    max-height: 60vh !important;
    overflow-y: auto !important; 
}
:deep(::-webkit-scrollbar) { width: 4px; }
:deep(::-webkit-scrollbar-thumb) { background: #888; border-radius: 10px; }

.grid-2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
}

.left-menu { top: 45px; left: 8px; width: fit-content }

input[type="color"] { border: none; width: 28px; height: 28px; padding: 0; cursor: pointer; border-radius: 4px; background: transparent; flex-shrink: 0; }
</style>